"use strict";

import { c as _c } from "react/compiler-runtime";
import { Box, OutsideClick, Portal } from '@autoguru/overdrive';
import clsx from 'clsx';
import { memo, useLayoutEffect } from 'react';
import * as styles from './Drawer.css';
import { jsx as _jsx } from "react/jsx-runtime";
const isServer = typeof window === 'undefined';

// This component should only ever be mounted on the client.
export const Drawer = /*#__PURE__*/memo(t0 => {
  const $ = _c(9);
  const {
    isOpen,
    onRequestClose,
    direction: t1,
    children,
    className: t2
  } = t0;
  const direction = t1 === undefined ? "LEFT_TO_RIGHT" : t1;
  const className = t2 === undefined ? "" : t2;
  let t3;
  let t4;
  if ($[0] !== isOpen) {
    t3 = () => {
      if (!isOpen || isServer) {
        return void 0;
      }
      document.documentElement.style.overflow = "hidden";
      return _temp;
    };
    t4 = [isOpen];
    $[0] = isOpen;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useLayoutEffect(t3, t4);
  let t5;
  if ($[3] !== children || $[4] !== className || $[5] !== direction || $[6] !== isOpen || $[7] !== onRequestClose) {
    t5 = isServer ? void 0 : /*#__PURE__*/_jsx(Portal, {
      container: document.body,
      children: /*#__PURE__*/_jsx(Box, {
        as: "aside",
        position: "fixed",
        width: "full",
        className: clsx(styles.root, className, {
          [styles.open]: isOpen,
          [styles.containerRTL]: direction === "RIGHT_TO_LEFT"
        }),
        children: /*#__PURE__*/_jsx(OutsideClick, {
          onOutsideClick: () => onRequestClose("overlay"),
          children: /*#__PURE__*/_jsx(Box, {
            as: "main",
            width: "full",
            height: "full",
            backgroundColour: "white",
            boxShadow: isOpen ? "2" : "none",
            className: clsx(styles.content, className, {
              [styles.fromLeft]: direction === "LEFT_TO_RIGHT",
              [styles.fromRight]: direction === "RIGHT_TO_LEFT",
              [styles.open]: isOpen
            }),
            children: children
          })
        })
      })
    });
    $[3] = children;
    $[4] = className;
    $[5] = direction;
    $[6] = isOpen;
    $[7] = onRequestClose;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
});
function _temp() {
  document.documentElement.style.overflow = null;
}